// node_modules
import { FC, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faTimes, faCheck, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
// Types
import { TTechnology } from "Types";
// styles
import styles from './technologyVotesModal.module.scss';
// Enums
import { TechnologyVoteTypeEnum } from "Enums";
// Contexts
import { AuthContext } from "Stores";
// Components
import { LetteredUserCircle, TechnologyVote, TechnologyVotesSummaryIcon } from "Components";

type TTechnologyVotesModalProps = {
    technology: TTechnology,
    handleOnMouseEnterModal: () => void,
    handleOnMouseLeaveModal: () => void
}

export const TechnologyVotesModal: FC<TTechnologyVotesModalProps> = ({ technology, handleOnMouseLeaveModal, handleOnMouseEnterModal }: TTechnologyVotesModalProps) => {
    // Contexts
    const { authState } = useContext(AuthContext);

    // Logic
    const getVotersCount = () => {
        let votersCount: number = 0;
        if (!technology.votes) return votersCount;
        if (technology.votes.currentUserVote) votersCount++;
        if (technology.votes.userVotes && technology.votes.userVotes.length >= 1) votersCount += technology.votes.userVotes.length;
        return votersCount;
    };

    const getUserTechnologyVoteTypeIcon = (vote: TechnologyVoteTypeEnum): IconProp => {
        let userTechnologyVoteTypeIcon: IconProp = faQuestion;

        switch (vote) {
            case TechnologyVoteTypeEnum.No:
                userTechnologyVoteTypeIcon = faTimes;
                break;
            case TechnologyVoteTypeEnum.Yes:
                userTechnologyVoteTypeIcon = faCheck;
                break;
            case TechnologyVoteTypeEnum.Super:
                userTechnologyVoteTypeIcon = faHeart;
                break;
            default:
                userTechnologyVoteTypeIcon = faQuestion;
                break;
        }

        return userTechnologyVoteTypeIcon;
    };

    const getUserTechnologyVoteIconClassByVote = (vote: TechnologyVoteTypeEnum): string => {
        let iconClass: string = styles.fontAwesomeItem;

        switch (vote) {
            case TechnologyVoteTypeEnum.No:
                iconClass = styles.fontAwesomeSelectedTimesItem;
                break;
            case TechnologyVoteTypeEnum.Yes:
                iconClass = styles.fontAwesomeSelectedCheckItem;
                break;
            case TechnologyVoteTypeEnum.Super:
                iconClass = styles.fontAwesomeSelectedHeartItem;
                break;
            default:
                iconClass = styles.fontAwesomeItem;
                break;
        }

        return iconClass;
    };

    const areThereAnyVotes = (): boolean => {
        return technology.votes &&
            (technology.votes.currentUserVote ||
                (technology.votes.userVotes && technology.votes.userVotes.length >= 1)) ? true : false;
    };

    return (
        <div onMouseEnter={handleOnMouseEnterModal} onMouseLeave={handleOnMouseLeaveModal} className={styles.technologyVotesModal}>
            {!technology.votes || !areThereAnyVotes() ?
                <div className={styles.technologyVoteSummary}>
                    <div className={styles.heartIconSummaryContainer}>
                        <TechnologyVotesSummaryIcon technology={technology} />
                    </div>
                    <span>No votes</span>
                </div>
                :
                <div className={styles.technologyVoteSummary}>
                    <div className={styles.heartIconSummaryContainer}>
                        <TechnologyVotesSummaryIcon technology={technology} />
                    </div>
                    <span>
                        {Math.round(technology.votes.averageVote * 100)}% ({getVotersCount()})
                    </span>
                </div>
            }
            <div className={styles.technologyVoteContainer}>
                <div className={styles.technologyVoteRow}>
                    <div className={styles.technologyVoteUser}>
                        <div className={styles.userCircleContainer}>
                            <LetteredUserCircle username={authState.userEmail} />
                        </div>
                        <div className={styles.currentUser}>You</div>
                    </div>
                    <TechnologyVote additionalClassName={styles.technologyUserVotesContainer} technology={technology} />
                </div>
                {technology.votes &&
                    technology.votes.userVotes &&
                    technology.votes.userVotes.length >= 1 ?
                    technology.votes.userVotes.map((userVote, index) => {
                        return (
                            <div className={styles.technologyVoteRow} key={index}>
                                <div className={styles.technologyVoteUser}>
                                    <div className={styles.userCircleContainer}>
                                        <LetteredUserCircle username={userVote.userName} />
                                    </div>
                                </div>
                                <div className={styles.technologyUserVotesContainer}>
                                    <FontAwesomeIcon icon={getUserTechnologyVoteTypeIcon(userVote.vote)} className={getUserTechnologyVoteIconClassByVote(userVote.vote)} />
                                </div>
                            </div>
                        );
                    })
                    :
                    <></>
                }
            </div>
        </div>
    );
};